import React, { useState, useEffect, useCallback } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import * as Yup from "yup";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
//imported
import { PROMOCODE } from "helpers/viewContent";
import {
  addData_,
  getDetail_,
  updateData_,
} from "store/services/commonService";
import * as Path from "routes/paths";
import * as actions from "store/actions/index.js";
import { DATE_FORMAT_TIME_ } from "helpers/common";

const AddEdit = ({ dispatch, match }) => {
  let editkey = match.params.id;
  const validationSchema = Yup.object().shape({
    // name: Yup.string().required('Full name is required'),
    title: Yup.string()
      .matches(/^[A-Za-z\s]+$/, "Only text characters are allowed in the title")
      .required("Title is required"),
    description: Yup.string().required("Description is required"),
    code: Yup.string().required("Code is required"),
    charges: Yup.string().required("Charges is required"),
    start_date_time: Yup.string().required("Start Date is required"),
    end_date_time: Yup.string().required("End Date is required"),
    status: Yup.string().required("Status is required"),
  });

  const validateData = async (data) => {
    try {
      await validationSchema.validate(data, { abortEarly: false });
      return { isValid: true, errors: {} };
    } catch (error) {
      const errors = {};
      error.inner.forEach((err) => {
        errors[err.path] = err.message;
      });
      return { isValid: false, errors };
    }
  };

  const history = useHistory();
  const [isShow, setIsShow] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [editData, setEditData] = useState({});

  const [fields, setfields] = useState({
    title: "",
    description: "",
    code: "",
    charges: "",
    start_date_time: "",
    end_date_time: "",
    status: "1",
  });
  const isValidDate = (current) => {
    const currentDate = new Date();
    return current.isSameOrAfter(currentDate, "day");
  };

  const handleChange = useCallback(
    (name) => (evt) => {
      setfields((prevState) => ({
        ...prevState,
        [name]: evt.target.value,
      }));
      setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    },
    [fields]
  );
  const handleChangePicker = async (selectedDate, name) => {
    let dateFormat = selectedDate
      ? selectedDate.format("YYYY-MM-DD hh:mm:ss")
      : "";
    // Check if start date is greater than end date
    if (
      name === "start_date_time" &&
      fields.end_date_time &&
      selectedDate.isAfter(fields.end_date_time)
    ) {
      // Display an error message
      // setValidationErrors(prev => ({
      //     ...prev,
      //     [name]: "Start date cannot be greater than end date",
      // }));
      setfields((prev) => ({
        ...prev,
        end_date_time: "",
      }));
    } else {
      // Clear any existing validation errors
      setValidationErrors((prev) => ({
        ...prev,
        [name]: "",
      }));

      // Update the state with the selected date
      setfields((prev) => ({
        ...prev,
        [name]: dateFormat,
      }));
    }
  };

  async function getData() {
    try {
      let query = {
        url: "promocode/view",
        id: editkey,
      };
      dispatch(actions.persist_store({ loader: true }));
      let res = await dispatch(getDetail_(query));
      setEditData(res?.body);
      let obj = {
        ...res?.body,
        start_date_time: DATE_FORMAT_TIME_(res?.body?.start_date_time),
        end_date_time: DATE_FORMAT_TIME_(res?.body?.end_date_time),
      };
      setfields(obj);
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      dispatch(actions.persist_store({ loader: false }));
      console.log(err);
    }
  }

  useEffect(() => {
    if (editkey) {
      getData();
    }
  }, []);

  //submit setting data
  const handleSubmit = async (evt) => {
    try {
      evt.preventDefault();
      const validation = await validateData(fields);
      if (validation.isValid) {
        dispatch(actions.persist_store({ loader: true }));
        setIsShow(true);
        let query = {};
        if (editkey) {
          query = {
            ...fields,
            url: "promocode/edit",
            id: editkey,
          };
          await dispatch(updateData_(query));
        } else {
          query = {
            ...fields,
            url: "promocode/add",
          };
          await dispatch(addData_(query));
        }
        setIsShow(false);
        dispatch(actions.persist_store({ loader: false }));
        history.push(Path.promocode);
      } else {
        setValidationErrors(validation.errors);
      }
    } catch (err) {
      setIsShow(false);
      dispatch(actions.persist_store({ loader: false }));
      console.log(err);
    }
  };
  return (
    <>
      <Helmet title={PROMOCODE.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-contacts menu-icon"></i>
          </span>{" "}
          {PROMOCODE.CURRENT_MODULE}
        </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.promocode}>{PROMOCODE.CURRENT_MODULE}</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Add/Edit
            </li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Add/Edit</h4>
              <form className="forms-sample" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="form-group col-md-6">
                    <label for="exampleInputName1">Title*</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputName1"
                      placeholder="Title*"
                      name="title"
                      onChange={handleChange("title")}
                      value={fields.title}
                    />
                    {validationErrors.title && (
                      <div className="text-danger err">
                        {validationErrors.title}
                      </div>
                    )}
                  </div>
                  <div className="form-group col-md-6">
                    <label for="exampleInputName1">Description*</label>
                    <textarea
                      type="text"
                      className="form-control"
                      id="exampleInputName1"
                      placeholder="Description*"
                      name="description"
                      onChange={handleChange("description")}
                      value={fields.description}
                    />
                    {validationErrors.description && (
                      <div className="text-danger err">
                        {validationErrors.description}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-md-6">
                    <label for="exampleInputName1">Code*</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputName1"
                      placeholder="Code*"
                      name="code"
                      onChange={handleChange("code")}
                      value={fields.code}
                    />
                    {validationErrors.code && (
                      <div className="text-danger err">
                        {validationErrors.code}
                      </div>
                    )}
                  </div>
                  <div className="form-group col-md-6">
                    <label for="exampleInputName1">Charges*</label>
                    <input
                      type="number"
                      className="form-control"
                      id="exampleInputName1"
                      placeholder="$ Charges*"
                      min={0}
                      name="charges"
                      onChange={handleChange("charges")}
                      value={fields.charges}
                    />
                    {validationErrors.charges && (
                      <div className="text-danger err">
                        {validationErrors.charges}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-md-6">
                    <label for="exampleInputName1">Start Date*</label>
                    <Datetime
                      key={fields.start_date_time}
                      value={fields.start_date_time || ""}
                      inputProps={{
                        placeholder: "YYYY-MM-DD hh:mm:ss",
                        readOnly: true,
                      }}
                      name="start_date_time"
                      dateFormat="YYYY-MM-DD"
                      timeFormat="hh:mm:ss"
                      isValidDate={isValidDate}
                      onChange={(selectedDate) =>
                        handleChangePicker(selectedDate, "start_date_time")
                      }
                      closeOnSelect={true}
                    />
                    {validationErrors.start_date_time && (
                      <div className="text-danger err">
                        {validationErrors.start_date_time}
                      </div>
                    )}
                  </div>
                  <div className="form-group col-md-6">
                    <label for="exampleInputName1">End Date*</label>
                    <Datetime
                      key={fields.end_date_time}
                      value={fields.end_date_time || ""}
                      inputProps={{
                        placeholder: "YYYY-MM-DD hh:mm:ss",
                        readOnly: true,
                      }}
                      name="end_date_time"
                      dateFormat="YYYY-MM-DD"
                      timeFormat="hh:mm:ss"
                      isValidDate={(current) =>
                        current.isAfter(fields?.start_date_time)
                      }
                      onChange={(selectedDate) =>
                        handleChangePicker(selectedDate, "end_date_time")
                      }
                      closeOnSelect={true}
                    />
                    {validationErrors.end_date_time && (
                      <div className="text-danger err">
                        {validationErrors.end_date_time}
                      </div>
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <div className="row">
                    <label for="exampleInputPassword4">Status*</label>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="">
                          <input
                            type="radio"
                            className=""
                            value={"1"}
                            name="status"
                            onChange={handleChange("status")}
                            checked={fields.status === "1" ? true : false}
                          />{" "}
                          Active
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="">
                          <input
                            type="radio"
                            className=""
                            value={"0"}
                            name="status"
                            onChange={handleChange("status")}
                            checked={fields.status === "0" ? true : false}
                          />{" "}
                          Inactive{" "}
                        </label>
                      </div>
                    </div>
                  </div>
                  {validationErrors.status && (
                    <div className="text-danger err">
                      {validationErrors.status}
                    </div>
                  )}
                </div>
                <button
                  type="submit"
                  disabled={isShow ? true : false}
                  className="btn btn-gradient-primary me-2"
                >
                  {isShow ? "Wait.." : "Submit"}
                </button>
                <Link to={Path.promocode}>
                  <button className="btn btn-outline-secondary btn-lg">
                    Back
                  </button>
                </Link>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToPros = (state) => {
  return {};
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(AddEdit);
